import React from 'react';
import {
    Box,
    Tooltip,
    CardContent,
    Checkbox,
    Button,
    Theme,
} from '@material-ui/core';
import { Trash as DeleteIcon } from 'react-feather';
import { useTranslation } from 'react-i18next';
import { IBulkActionsHeader } from './types';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles((theme: Theme) => ({
    deleteButton: {
        backgroundColor: theme.palette.error.main,
        '&:hover': {
            backgroundColor: theme.palette.error.dark,
        },
        textTransform: 'capitalize',
    },
}));

/**
 * Represents the header of the filters section of the document list view.
 *
 * @return {*}
 */
export const BulkActionsHeader = ({
    setDeleteModalOpen,
}: IBulkActionsHeader) => {
    const { t } = useTranslation();
    const classes = useStyles();
    const labelDelete: string = t('Buttons.Delete');

    const handleDelete = async () => setDeleteModalOpen(true);

    return (
        <CardContent
            style={{
                display: 'flex',
                alignItems: 'center',
                gap: 10,
                height: 80,
            }}
        >
            <Box
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 20,
                }}
            >
                <Tooltip title={labelDelete}>
                    <Button
                        onClick={handleDelete}
                        data-testid="delete-button"
                        variant="contained"
                        color="primary"
                        startIcon={<DeleteIcon />}
                        className={classes.deleteButton}
                    >
                        {labelDelete}
                    </Button>
                </Tooltip>
            </Box>
        </CardContent>
    );
};
